/**
 * Fetch information about browser
 */
export const fetchBrowserInfo = () => ({
  userAgent: navigator.userAgent,
  platform: (navigator as any).userAgentData?.platform || '',
  screen: {
    width: screen.width,
    height: screen.height,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    pixelRatio: window.devicePixelRatio,
  },
  locale: navigator.language,
});
